import env from './env';

export const isPublic = () => {
  return env.KC_PARTITION === 'public';
};

export const isGov = () => {
  return env.KC_PARTITION === 'gov';
};
